// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllSegments } from '../state/actions/SegmentActions';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, FormText } from 'reactstrap';
import { ImageSquare } from '../containers/ImageSquare'; 


//COMPONENT

class PlanogramDetailsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            allSegments: [],
            isValid: true,
            name: '',
            segmentIds: {},
            nameValid: true,
            iconValid: true,
            selectedIcon: '',
            segmentsValid: true,
            icons: ['cafe.png', 'dairy.png', 'fastfood.png', 'restaurant.png', 'supermarket.png']
        };

        this.dismissModal = this.dismissModal.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
        this.validate = this.validate.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.selectedSegmentsChanged = this.selectedSegmentsChanged.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.imageSelected = this.imageSelected.bind(this);
    }

    componentDidMount(){
        this.props.getAllSegments();
    }

    componentDidUpdate(prevProps) {
        if (this.props.allSegments != prevProps.allSegments) {
            this.setState({ allSegments: prevProps.allSegments});
        }
    }

    dismissModal(){
        this.props.toggleModal();
    }

    typeChange(e){
        this.setState({type: e.target.value.toLowerCase()});
    }

    nameChange(event) {
        this.setState({name: event.target.value});
    }

    selectedSegmentsChanged(e){
        var options = e.target.options;
        var value = {};
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                let id = this.getSegmentID(options[i].value);
                if(id != undefined && id != null){
                    value[id] = true;
                }
            }
        }
        this.setState({segmentIds: value});
    }

    getSegmentID(name){
        return this.state.allSegments.find(segment => segment.name === name).id;
    }

    saveDetails(){
        if(this.validate()){
            this.props.saveDetails({
                name: this.state.name,
                icon: this.state.selectedIcon,
                segmentIds: this.state.segmentIds,
            });
            this.props.toggleModal();
        }
    }

    validate(){
        this.setState({nameValid: this.state.name != ''});
        this.setState({iconValid: this.state.selectedIcon != ''});
        this.setState({segmentsValid: JSON.stringify(this.state.segmentIds) != JSON.stringify({})});

        if(this.state.name != '' && this.state.selectedIcon != '' && JSON.stringify(this.state.segmentIds) != JSON.stringify({})){
            return true;
        } 
        return false;
    }

    imageSelected(image){
        if(image == this.state.selectedIcon){
            this.setState({selectedIcon: ''});
        } else {
            this.setState({
                selectedIcon: image,
                iconValid: true
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Planogram Details</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input invalid={!this.state.nameValid} className="planogram-input textfield" placeholder="Name"  type="text" onChange={this.nameChange} value={this.state.name}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="typeSelect">Icon</Label>
                            <div className="image-selection-container">
                                {this.state.icons.map((icon) => { return( <ImageSquare key={icon} isSelected={this.state.selectedIcon == icon} image={icon} imageSelected={this.imageSelected}/>);})}
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <Label>Segments</Label>
                            <Input invalid={!this.state.segmentsValid} className="planogram-input" multiple type="select" name="select" id="typeSelect" onChange={this.selectedSegmentsChanged}>
                                {this.state.allSegments.map((segment) => {return (<option key={segment.id}>{segment.name}</option>);})}
                            </Input>
                            <FormText color="muted"> Select the segments that you want this planogram to appear under </FormText>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="button" onClick={this.props.toggleModal}>Cancel</Button>
                        <Button className="button" color="primary" onClick={this.saveDetails}>Save</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

PlanogramDetailsModal.propTypes = {
    getAllSegments: PropTypes.func.isRequired,
    allSegments: PropTypes.array.isRequired,
    fetchingAllSegments: PropTypes.bool.isRequired,
    fetchedAllSegments: PropTypes.bool.isRequired,
    failedAllSegments: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    saveDetails: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { allSegments, fetchingAllSegments, fetchedAllSegments, failedAllSegments} = state.segmentReducer;
    return { allSegments, fetchingAllSegments, fetchedAllSegments, failedAllSegments };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getAllSegments }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanogramDetailsModal));

// EXPORT COMPONENT
export { hoc as PlanogramDetailsModal };


// WEBPACK FOOTER //
// ./src/components/modals/PlanogramDetailsModal.js